// extracted by mini-css-extract-plugin
export default {"link":"dashboard-verification-transactions-table-container__link__EdmAq"};